import React from "react";
import { UserDTO } from "./UserDTO";

type AuthCtxType = {
  user?: UserDTO;
};
const AuthCtx = React.createContext<AuthCtxType>({});

export { AuthCtx };
